'use client';

import { type ReactNode } from 'react';

import { BaseDrawer } from './base-drawer';
import { DrawerModeProvider } from './drawer-mode-context';
import { useDrawerMaxHeight } from './use-drawer-max-height';

interface PopoverDrawerProps {
	open: boolean;
	onClose: () => void;
	/** Stack as a nested Vaul drawer when already inside another drawer. */
	nested: boolean;
	dismissible: boolean;
	children: ReactNode;
}

/**
 * Mobile presentation of a Popover: renders its content in a bottom sheet.
 * Handle-only (no title bar); fits content, caps at the keyboard-aware height,
 * and scrolls beyond it.
 */
export const PopoverDrawer = ({ open, onClose, nested, dismissible, children }: PopoverDrawerProps) => {
	const maxHeight = useDrawerMaxHeight();

	return (
		<BaseDrawer
			open={open}
			onClose={onClose}
			nested={nested}
			title="Options"
			padding="compact"
			maxHeight={maxHeight}
			dismissible={dismissible}
			stopPointerPropagation
		>
			<div className="flex-1 min-h-0 overflow-y-auto">
				<DrawerModeProvider>{children}</DrawerModeProvider>
			</div>
		</BaseDrawer>
	);
};
